/**
* Checkmarks Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Checkmarks Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'checkmarks-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.checkmarks-grid' ).each( function( key, val ) {
        ScrollTrigger.create( {
          trigger: this,
          start: 'top 50%',
          scrub: 0.15,
          onRefresh: ( self ) => {
            if ( self.progress > 0 ) {
              $( this ).addClass( 'is-loaded' );
            }
          },
          onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'is-loaded' ),
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'checkmarks-grid', COMPONENT );
} )( app );
